const STORAGE_KEY = 'bono_master_catalog_revision';

/** Last applied master-data `catalog_revision` from the server (browser localStorage). */
export function getLastMasterCatalogRevision(): string | null {
  try {
    const v = globalThis.localStorage?.getItem(STORAGE_KEY);
    return v != null && v.trim() !== '' ? v.trim() : null;
  } catch {
    return null;
  }
}

/** Persists revision after a successful apply (enables idempotent skip on next download). */
export function setLastMasterCatalogRevision(revision: string): void {
  try {
    globalThis.localStorage?.setItem(STORAGE_KEY, revision.trim());
  } catch {
    /* private mode / quota */
  }
}

/** @internal Vitest */
export function clearLastMasterCatalogRevisionForTests(): void {
  try {
    globalThis.localStorage?.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}
